import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconPolitics: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPolitics"><Path d="M5.5 7.5V5L8 3" stroke="currentColor"/><Path d="M18.5 7.5V5L16 3" stroke="currentColor"/><Circle cx="8" cy="3.0498" r="1.5" fill="currentColor"/><Circle cx="16" cy="3.0498" r="1.5" fill="currentColor"/><Path d="M3.5 7.5H20.5V11.5H3.5V7.5Z" stroke="currentColor"/><Path d="M4.5 11.5L5.5 20.5H18.5L19.5 11.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconPolitics;
